export class Camera {
  x = 0;
  y = 0;

  constructor(public viewW: number, public viewH: number) {}

  follow(targetX: number, targetY: number, levelWidth: number, levelHeight: number): void {
    this.x = targetX - this.viewW / 2;
    this.y = targetY - this.viewH / 2;

    if (this.x < 0) this.x = 0;
    if (this.y < 0) this.y = 0;

    const maxX = Math.max(0, levelWidth - this.viewW);
    const maxY = Math.max(0, levelHeight - this.viewH);
    if (this.x > maxX) this.x = maxX;
    if (this.y > maxY) this.y = maxY;
  }
}
